import { SVGProps } from "react";

export const CampaignIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={21}
    fill="none"
    {...props}
  >
    <path
      fill="var(--start-color, #000)"
      d="M11 19.554a.765.765 0 0 0-.53.212.71.71 0 0 0-.22.511.71.71 0 0 0 .22.511c.14.136.33.212.53.212v-1.446Zm-4.045 1.382a.777.777 0 0 0 .543-.18.727.727 0 0 0 .25-.498.698.698 0 0 0-.187-.523.748.748 0 0 0-.516-.242l-.09 1.443ZM1.25 10.64c0 1.806 0 3.691.169 5.268.085.79.215 1.532.422 2.163.203.622.503 1.21.979 1.618l.996-1.08c-.183-.157-.377-.461-.545-.972-.164-.501-.28-1.135-.36-1.877-.16-1.488-.161-3.292-.161-5.12h-1.5ZM11 21c2.102 0 3.746.001 5.027-.146 1.293-.149 2.33-.46 3.153-1.166l-.996-1.08c-.495.424-1.178.677-2.335.81-1.17.134-2.71.136-4.85.136V21Zm-3.955-1.508c-1.714-.099-2.613-.357-3.23-.884l-.995 1.08c1.016.87 2.363 1.145 4.135 1.248l.09-1.444Zm12.205-8.48c0 1.765-.013 3.485-.178 4.896-.082.705-.2 1.304-.36 1.778-.164.482-.352.77-.528.922l.996 1.08c.46-.394.755-.957.957-1.552.206-.605.338-1.312.426-2.066.176-1.506.186-3.308.187-5.058h-1.5Z"
    />
    <path
      stroke="var(--start-color, #000)"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="m13.66 12.761 3.004-.868m-8.324.867-6.008-1.736c-.595-.172-.893-.258-1.082-.464a.968.968 0 0 1-.1-.13C1 10.196 1 9.897 1 9.298c0-2.362 0-3.542.673-4.34.13-.154.275-.293.434-.418.827-.648 2.052-.648 4.502-.648h8.782c2.45 0 3.675 0 4.502.648.16.126.305.265.434.419C21 5.756 21 6.936 21 9.298c0 .6 0 .898-.15 1.132a.965.965 0 0 1-.1.13c-.15.163-.369.25-.75.366"
    />
    <path
      stroke="var(--start-color, #000)"
      strokeWidth={1.5}
      d="M5.5 3.892c.823-.02 1.66-.526 1.94-1.273l.035-.099.025-.074c.042-.123.064-.183.086-.237a1.94 1.94 0 0 1 .686-.845c.308-.213.671-.338 1.049-.36C9.38 1 9.448 1 9.58 1h2.838c.133 0 .2 0 .26.004.378.022.741.147 1.049.36.307.213.545.506.686.845.023.054.044.115.086.237l.026.074.035.1c.28.746 1.116 1.252 1.939 1.272"
    />
    <path
      stroke="var(--start-color, #000)"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M13 11.12H9a.51.51 0 0 0-.354.142.473.473 0 0 0-.146.34v2.084c0 .097.03.19.086.27.056.08.135.142.228.178l.7.27a4.14 4.14 0 0 0 2.972 0l.7-.27a.497.497 0 0 0 .228-.178.47.47 0 0 0 .086-.27v-2.084a.474.474 0 0 0-.146-.34.51.51 0 0 0-.354-.142Z"
    />
  </svg>
);
